import { Factory, Model } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randSentence, randNumber } from '@ngneat/falso'

import type { Schemas } from '../../types.js'
import type { MockServer } from '../server.js'
import { CONSTANTS } from './constants.js'
import {
  handleCreateMessage,
  handleSendMessageToThread,
  handleResendMessage,
} from './handlers/messages.js'

export type ConversationMessage = NonNullable<
  Schemas['ConversationSendMessageToClientRequest']['data']['attributes']
>

export const model = Model as ModelDefinition<ConversationMessage>

export const factory = Factory.extend<ConversationMessage>({
  client_id: () => randNumber(CONSTANTS.conversationMessage.clientIdRange),
  channel: () => CONSTANTS.conversationMessage.defaultChannel,
  content: () => randSentence(),
  upload_group_id: () => '',
})

export function routes(server: MockServer) {
  server.post('/conversations/messages', handleCreateMessage)

  server.post('/conversations/threads/:id/messages', handleSendMessageToThread)

  server.post(
    '/conversations/threads/:id/messages/:message_id/resend',
    handleResendMessage,
  )
}

export function seeds() {}
